var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9992 16C31.9992 24.8367 24.8359 32 15.9992 32C7.16328 31.9992 0 24.8359 0 16C0 7.16328 7.16328 0 16 0C24.8367 0 32 7.16328 32 16H31.9992Z",
    fill: "#333D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8939 9.21924H9.10373C7.74114 9.21924 6.63625 10.3241 6.63625 11.6859V20.3108C6.63625 21.6734 7.74114 22.7775 9.10373 22.7775H22.8939C24.2557 22.7775 25.3606 21.6734 25.3606 20.3108V11.6859C25.3606 10.3241 24.2557 9.21924 22.8939 9.21924ZM18.2135 16.5943L14.3785 18.511C13.9356 18.7324 13.4154 18.4111 13.4154 17.9166V14.0833C13.4154 13.5889 13.9364 13.2676 14.3785 13.4882L18.2135 15.4049C18.7031 15.6497 18.7031 16.3495 18.2135 16.5943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.e09e1b6ef432ef8b1bca081647fa087b.svg";
export { ForwardRef as ReactComponent };